import { render, staticRenderFns } from "./BrowseContent.vue?vue&type=template&id=61e90c7c&"
import script from "./BrowseContent.vue?vue&type=script&lang=js&"
export * from "./BrowseContent.vue?vue&type=script&lang=js&"
import style0 from "./BrowseContent.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports